import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import MenuItems from './MenuItems';

import normalLogo from '../../assets/images/logos/logo.png';
import stickyLogo from '../../assets/images/logos/logo.png';
import Swal from 'sweetalert2';

const Header = (props) => {
	const { headerClass, parentMenu, headerNormalLogo, headerStickyLogo } = props;
	const navigate = useNavigate();

	const [menuOpen, setMenuOpen] = useState(false)
	const [isVisible, setIsVisible] = useState(false);
	const roleFromLocal = (localStorage.getItem('guest_user_role') || '').toLowerCase();
	const roleFromSession = (sessionStorage.getItem('guest_user_role') || '').toLowerCase();
	const isInstitutionLoggedIn = roleFromLocal === 'institution' || roleFromSession === 'institution';

	const handleLogout = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out of your account.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#1e40af',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, logout'
        }).then((result) => {
            if (result.isConfirmed) {
    		localStorage.removeItem('guest_user_role');
    		localStorage.removeItem('guest_access_token');
    		localStorage.removeItem('guest_refresh_token');
    		sessionStorage.removeItem('guest_user_role');
    		Swal.fire({
                title: 'Logged Out',
                text: 'You have successfully logged out.',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
                confirmButtonColor: '#1e40af'
            }).then(() => {
                navigate('/login');
            });
            }
        });
	};

	useEffect(() => {
		// Sticky is displayed after scrolling for 100 pixels
		const toggleVisibility = () => {
			if (window.pageYOffset > 100) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		};

		window.addEventListener("scroll", toggleVisibility);

		return () => window.removeEventListener("scroll", toggleVisibility);
	}, []);

	return (
		<>

			<header id="react-header" className={headerClass ? headerClass : 'react-header react-header-three'}>
				<div className={isVisible ? 'header-area react-sticky' : 'header-area'}>
					{/* Top contact bar removed per request */}
					<div className="menu-part">
						<div className="container">
							<div className="react-main-menu">
								<nav>
									<div className="menu-toggle">
										<div className="logo">
											{
												isVisible ? 
												<Link to="/" className="logo-text">
													<img src={headerStickyLogo ? headerStickyLogo : stickyLogo} alt="" style={{height: '55px'}} />
												</Link> :
												<Link to="/" className="logo-text">
													<img src={headerNormalLogo ? headerNormalLogo : normalLogo} alt="" style={{height: '55px'}} />
												</Link>
											}
										</div>
										<button type="button" id="menu-btn" className={menuOpen ? "mobile-menu-btn open" : "mobile-menu-btn"} onClick={() => {setMenuOpen(!menuOpen)}}>
											<span className="icon-bar"></span>
											<span className="icon-bar"></span>
											<span className="icon-bar"></span>
										</button>
									</div>
									<div className={menuOpen ? "react-inner-menus menu-open" : "react-inner-menus"}>
										<ul id="backmenu" className="react-menus react-sub-shadow">
											<MenuItems 
												parentMenu = {parentMenu}
											/>
										</ul>                                
										<div className="searchbar-part">
											{isInstitutionLoggedIn ? (
												<button
													type="button"
													onClick={handleLogout}
													className="react-btn-primary"
													style={{
														background: '#1e40af',
														border: '2px solid #1e3a8a',
														padding: '8px 20px',
														borderRadius: '8px',
														color: '#fff',
														fontWeight: '600',
														fontSize: '14px',
														boxShadow: '0 4px 8px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.3)',
														textDecoration: 'none',
														display: 'inline-block',
														textTransform: 'none',
														cursor: 'pointer'
													}}
												>
													Logout
												</button>
											) : (
												<Link to="/login" className="react-btn-primary" style={{
													background: '#1e40af',
													border: '2px solid #1e3a8a',
													padding: '8px 20px',
													borderRadius: '8px',
													color: '#fff',
													fontWeight: '600',
													fontSize: '14px',
													boxShadow: '0 4px 8px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.3)',
													textDecoration: 'none',
													display: 'inline-block',
													textTransform: 'none'
												}}>
													Login
												</Link>
											)}
										</div>
									</div>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
}

export default Header;